<!--
 * @Author: linrui
 * @Date: 2021-12-20 16:29:11
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-17 19:41:25
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/doctorRegister.vue
-->

<template>
    <div class="doctor-register">
        <!-- S 签字板 -->
        <div class="canvas-page" @touchmove.prevent>
            <template>
                <div class="canvas-box" id="canvas-box">
                    <canvas id="canvas">Canvas画板</canvas>
                </div>
                <div class="page-ft btn" v-if="!showSignImgBox">
                    <van-row>
                        <van-col span="12">
                            <van-button class="back" @click.native="clear">清除</van-button>
                        </van-col>
                        <van-col span="12">
                            <van-button class="up" @click.native="save">保存</van-button>
                        </van-col>
                    </van-row>
                </div>
            </template>
        </div>
        <!-- E 签字板 -->

        <van-popup class="doctor-apply" v-model="showSignImgBox" style="width:100%;height:100%">

            <div class="doctor-cell-group">

                <!-- S 医生基本信息表单 -->
                <van-cell-group class="shadow-box">
                    <van-field class="required" readonly required v-model="doctorReg.formdata.name" label="姓名" placeholder="请输入真实姓名"></van-field>
                    <van-field class="required" required v-model.trim="doctorReg.formdata.email" label="邮箱" placeholder="请输入您的邮箱"></van-field>
                    <van-field class="required" v-model.trim="doctorReg.formdata.fax" label="传真" placeholder="请输入您的传真"></van-field>
                    <van-field class="required" required v-model.trim="doctorReg.formdata.address" label="联系地址" placeholder="可接收项目专用章地址"></van-field>
                    <van-field class="required" maxlength="6" v-model.trim="doctorReg.formdata.postalcode" label="邮编" placeholder="请输入您的邮编"></van-field>
                </van-cell-group>
                <!-- E 医生基本信息表单 -->

                <!-- S 医生工作信息表单 -->
                <van-cell-group class="shadow-box">
                    <!-- <van-field  required label="所属医院" v-model="doctorReg.formdata.hospital" readonly @click.native="showHospitalSearch" input-align="left" is-link>
                    </van-field> -->
                    <van-field class="required" required v-model.trim="doctorReg.formdata.hospital" label="所属医院" placeholder="请输入所属医院的全称"></van-field>
                    <van-field  required label="所属科室" v-model="doctorReg.formdata.department" readonly @click.native="showDepartment = true" input-align="left" is-link>
                    </van-field>
                    <van-field  required label="职称" v-model="doctorReg.formdata.job" input-align="left" readonly @click.native="showJob = true" is-link>
                    </van-field>
                </van-cell-group>
                <!-- E 医生工作信息表单 -->  
                
                <!-- S 认证材料二选一选择框-->
                <div class="confirm-checkitems">
                    <p class="custom-title">认证材料</p>
                    <p class="sub-title">选择材料类型<span style='color:red'>*（两类材料二选一）</span></p>
                    <van-checkbox-group class="checkboxStyle  shadow-box" v-model="mType" direction="horizontal" :max="1">
                        <van-checkbox v-for="(mitem, mindex) in mArr" :key="mindex" :name="mitem.key" @click="handleCheckboxChange(mitem.key)">{{mitem.value}}</van-checkbox>
                    </van-checkbox-group>
                </div>
                <!-- E 认证材料二选一选择框-->
            
                <!-- S 认证材料表单 -->
                <template v-if="checkItemsShow">
                    <div v-show="mType && mType.includes(1)">
                        <div class="myuploader shadow-box" v-for="(item, index) in checkItems1" :key="index">
                            <image-uploader
                                ref="imgUploader1"
                                :title="(index+1)+'. '+item.name"
                                :value="item.images"
                                :temp="item.examples[0].src"
                                :history="item.history"
                                :num="item.num"
                                @deleteCI="deleteCI"
                            >
                            </image-uploader>
                        </div>
                    </div>
                    <div v-show="mType && mType.includes(2)">
                        <div class="myuploader shadow-box" v-for="(item2, index2) in checkItems2" :key="'2'+ index2">
                            <image-uploader
                                ref="imgUploader2"
                                :title="(index2+1)+'. '+item2.name"
                                :value="item2.images"
                                :history="item2.history"
                                :temp="item2.examples[0].src"
                                :num="item2.num"
                                @deleteCI="deleteCI"
                            >
                            </image-uploader>
                        </div>
                    </div>
                </template>
                <!-- E 认证材料表单 -->
                
                <!-- S 医生签名设置展示栏 -->
                <div class="shadow-box">
                    <van-cell-group class="sign-img-box">

                        <van-cell value="去设置" is-link label="用于项目医学材料核对中" @click.native="handleImageBoxConfig">
                            <div slot='title'>手写签名<span style='color:red'>*</span></div>
                        </van-cell>
                        <div style="padding: 10px;" v-if="sign_img">
                            <div class="sign_img">
                                <img :src="sign_img" alt="" @click="showImage(sign_img)">
                            </div>
                        </div>
                        
                    </van-cell-group>
                </div>
                <!-- E 医生签名设置展示栏 -->

                <!-- S 底部提交栏 -->
                <div class="doc-agree">
                    <van-checkbox v-model="hasAgreed" checked-color="#2aa8b1">我已同意在“择美同行患者援助方案项目”医生备案系统进行个人信息采集，并确认以上信息真实有效。</van-checkbox>
                </div>
                <div class="btn">
                    <van-button class="up" v-if="!hasAgreed" type="primary" disabled>提交</van-button>
                    <van-button class="up" v-else type="primary" :disabled="submitBtnDisabled" @click.native="submitForm()">提交</van-button>
                </div>
                <!-- E 底部提交栏 -->
            </div>
        </van-popup>

        <!-- S 医师职称列表 -->
        <van-popup v-model="showJob" round position="bottom">
            <van-picker :columns="jobArr" title="职称" show-toolbar placeholder="请选择职称" @confirm="getJob" @cancel="showJob = false">
            </van-picker>
        </van-popup>
        <!-- E 医师职称列表 -->

        <!-- S 医院列表搜索 -->
        <van-popup v-model="showHospital" style="width:100%;height:50%" position="bottom">
            <div class="van-popup-fixbox van-popup-search-box">
                <van-search
                    show-action
                    v-model.trim="hospitalKeywords"
                    placeholder="请您输入医院关键字查询医院"
                    @search="getSearchHosResult"
                >
                    <template #action>
                        <div class="search-hospital-button">
                            <div class="action-btn">
                                <van-button class="up" @click="getSearchHosResult">搜索</van-button>
                            </div>
                            <div class="cancel-btn" @click="closeHospitalSearch">取消</div>
                        </div>
                    </template>
                </van-search>
                <van-cell-group>
                    <van-cell v-for="(item, index) in searchHospitalResults" :key="index" :value="item.name" @click.native="chooseHospital(item)"></van-cell>
                </van-cell-group>
            </div>
        </van-popup>
        <!-- S 医院列表搜索 -->

        <!-- S 科室列表搜索 -->
        <van-popup v-model="showDepartment" position="bottom" style="width:100%;height:50%">
            <div class="van-popup-fixbox">
                <van-search
                    show-action
                    v-model="departmentKeywords"
                    placeholder="请您输入关键字查询科室"
                    @search="getSearchDepResult"
                    @cancel="closeDepartmentSearch"
                >
                </van-search>
                <van-cell-group>
                    <van-cell v-for="(item, dindex) in searchDepartmentResults" :key="dindex" :value="item" @click.native="chooseDepartment(item)"></van-cell>
                </van-cell-group>  
            </div>
        </van-popup>
        <!-- E 科室列表搜索-->

        <!-- S 医师公益平台医生已有签名展示 -->
        <van-popup v-model="showPreSignature" style="width:100%; height:100%">
            <div class="pre-signature">
                <div class="signature-box">
                    <van-image :src='preSignImg'></van-image>
                </div>
                <p class="signature-tips" v-if="isAdopted">以上是您的医师公益平台医生签名，是否采用到择美同行项目医生备案表中？</p>
                <div class="page-ft btn">
                    <van-row>
                        <van-col span="12">
                            <van-button class="back" @click="reSign">重新签名</van-button>
                        </van-col>
                        <van-col span="12">
                            <van-button class="up" @click="confirmPreSign">确认使用</van-button>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </van-popup>
        <!-- E 医师公益平台医生已有签名展示 -->
    </div>
</template>

<script>
import {
    GetDoctorHospital,
    GetDepartmentJob,
    RemoveDocInfoAttach,
    GetDoctorDetail,
    SubmitDoctorInfo
} from '../../api/api'
import { mapState } from "vuex";
import ImageUploader from "@/components/ImageUploaderDoctor";

import temp_idc1 from "@/assets/temp_idc1.jpg"
import temp_idc2 from "@/assets/temp_idc2.jpg"
import temp_dc1 from "@/assets/temp_dc1.jpg"
import temp_dc2 from "@/assets/temp_dc2.jpg"

import temp_wc1 from "@/assets/temp_wc1.jpg"

import idcard_front from "@/assets/idcard_front.png";
import idcard_back from "@/assets/idcard_back.png";
import { ImagePreview, Dialog } from 'vant';

var draw;
var isDraw = false;
var preHandler = function(e) {
    e.preventDefault();
};
class Draw {
    constructor(el) {
        this.el = el;
        this.canvas = document.getElementById(this.el);
        this.cxt = this.canvas.getContext("2d");
        this.cw = document.getElementById("canvas-box").clientWidth - 30;
        this.ch = document.getElementById("canvas-box").clientHeight - 30;
        this.canvas.width = this.cw;
        this.canvas.height = this.ch;
        this.stage_info = canvas.getBoundingClientRect();
        this.path = {
            beginX: 0,
            beginY: 0,
            endX: 0,
            endY: 0
        };
    }
    init(btn) {
        var that = this;

            this.canvas.addEventListener("touchstart", function(event) {
            document.addEventListener("touchstart", preHandler, false);
            that.drawBegin(event);
        });
        this.canvas.addEventListener("touchend", function(event) {
            document.addEventListener("touchend", preHandler, false);
            that.drawEnd();
        });
        this.clear(btn);
    }
    drawBegin(e) {
        var that = this;
        window.getSelection()
        ? window.getSelection().removeAllRanges()
        : document.selection.empty();
        this.cxt.strokeStyle = "#000";
        this.cxt.beginPath();
        this.cxt.moveTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        );
        this.path.beginX = e.changedTouches[0].clientX - this.stage_info.left;
        this.path.beginY = e.changedTouches[0].clientY - this.stage_info.top;
        canvas.addEventListener("touchmove", function() {
            that.drawing(event);
        });
    }
    drawing(e) {
        this.cxt.lineTo(
            e.changedTouches[0].clientX - this.stage_info.left,
            e.changedTouches[0].clientY - this.stage_info.top
        );
        this.path.endX = e.changedTouches[0].clientX - this.stage_info.left;
        this.path.endY = e.changedTouches[0].clientY - this.stage_info.top;
        this.cxt.stroke();
    }
    drawEnd() {
        document.removeEventListener("touchstart", preHandler, false);
        document.removeEventListener("touchend", preHandler, false);
        document.removeEventListener("touchmove", preHandler, false);
        //canvas.ontouchmove = canvas.ontouchend = null
        isDraw = true;
    }
    clear(btn) {
        this.cxt.clearRect(0, 0, this.cw, this.ch);
        isDraw = false;
    }
    save() {
        return canvas.toDataURL("image/png");
    }
}
export default {
    components: {
        ImageUploader
    },
    name: "DoctorRegister",
    data() {
        return {
            idcard_front,//身份证正面示例图片
            idcard_back,//身份证反面示例图片
            showPreSignature:false,//是否展示之前的签名
            showSignImgBox:true,//是否展示填写信息页
            isAdopted:null,//是否采用医师公益平台的信息
            sign_img: '',//本次签名图片
            preSignImg:'',//已有的签名图片
            submitBtnDisabled: false,//禁用按钮
            hospitalArr:[],//从医联获取到的医院arr
            showHospital:false,//显示搜索医院列表
            hasAgreed: false,//同意备案个人信息选项
            showDepartment: false,//展示科室搜索弹窗
            hospitalResults: [], //所有医院数据
            hospitalKeywords:'',//医院搜索关键字
            searchHospitalResults: [],//当前搜索的医院数据
            departmentKeywords:'',//科室搜索关键字
            departmentResults: [],//所有科室数据
            searchDepartmentResults:[],//当前搜索的科室数据
            jobArr:[],//职称数组
            showJob: false,//展示职称弹窗
            temp_signature_image:'',//暂存过去的签名照片
            doctorReg: {
                formdata: {
                    id:'',//医生id
                    name: '',//医生姓名
                    email: '',//医生邮箱
                    fax: '',//传真
                    address:'',//医生地址
                    postalcode:'',//医生邮编
                    // hospital: '请选择所属医院',
                    hospital:'',
                    department: '请选择科室',
                    job: '请选择职称',
                    signature_image:'',//签名图片
                    attaches: {}//上传的材料
                },
            },
            // mType: {key:1, value:'执业医师资格证'}, // 材料类型，1：执业医师资格；2：身份证
            mType: [1], // 材料类型，1：执业医师资格；2：身份证
            mArr: [
                {
                    key: 1,
                    value: '执业医师资格证',
                },
                {
                    key: 2,
                    value: '身份证+卫健委截图'
                }
            ],//材料类型数据
            checkItemsObj:{
                idcard_front: "身份证人像面",
                idcard_back: "身份证国徽面",
                caram: "卫健委网站医生注册信息查询截图",
                headattach: "执业医生资格证人像页",
                infoattach: "执业医生资格证身份信息页"
            },
            checkItems1: [], // 执业医师资格证（含：执业医生资格证人像页，执业医生资格证身份信息页）
            checkItems2: [], // 身份证（含：身份证正面，身份证背面，卫健委网站医生执业注册信息查询截图）
            checkItemsShow: false,
            timer: null,
            examples: {
                idcard_front: [
                {
                    title: '示例',
                    src: temp_idc2,
                }
                ],
                idcard_back: [
                {
                    title: '示例',
                    src: temp_idc1,
                }
                ],
                headattach: [
                {
                    title: '示例',
                    src: temp_dc1,
                }
                ],
                infoattach: [
                {
                    title: '示例',
                    src: temp_dc2,
                }
                ],
                caram:[{
                    title:'示例',
                    src:temp_wc1
                }]
            },
        };
    },

    computed: {
        ...mapState({
            doctorInfo: state => state.doctor.doctorInfo,
        })
    },

    async created() {
        await this.initData()
        const keys = Object.keys(this.checkItemsObj)
        const values = Object.values(this.checkItemsObj)
        let NameItems1 = ['infoattach','headattach'];
        let NameItems2 = ['idcard_front','idcard_back','caram'];
        
        let NowArray = []
        for(let i in keys) {
            let num = 9
            if( NameItems1.includes(keys[i]) ) {
                NowArray =   this.checkItems1
            }
            if( NameItems2.includes(keys[i]) ) {
                NowArray =   this.checkItems2
            }
            NowArray.push({
                field: keys[i],
                name: values[i],
                num: num,
                images: [],
                examples: this.examples[keys[i]],
                history: []
            })
        }
        console.log('field', this.checkItems1, this.checkItems2)
        this.checkItemsShow = true
    },

    mounted() {
        draw = new Draw("canvas")
        draw.init()
    },

    methods: {
        async initData() {
            if(this.$route.query) {
                this.isAdopted = this.$route.query.isAdopted
            }
            this.$toast.loading({
                duration:0,
                forbidClick:true
            })
            // await GetDoctorHospital().then( res => {
            //     console.log(res,'医师医院列表')
            //     this.hospitalResults = res.data
            //     this.searchHospitalResults = this.hospitalResults 
            // }).catch( err => {
            //     this.$toast(err.response.data.message)
            // })

            await GetDepartmentJob().then( res => {
                console.log(res,'医师科室职称列表')
                this.departmentResults = res.data.departments
                this.searchDepartmentResults = this.departmentResults
                this.jobArr = res.data.jobs
            }).catch( err => {
                this.$toast(err.response.data.message)
            })

            if( this.isAdopted == null || this.isAdopted) {
                GetDoctorDetail({
                    params:{id:this.doctorInfo.id}
                }).then( res => {
                    console.log(res.data.doctor,'泽美医生信息')
                    console.log(res.data.attaches,'泽美医生材料信息')
                    let attachesKeys = Object.keys(res.data.attaches)
                    let attachesValues = Object.values(res.data.attaches)
                    console.log(attachesKeys,'attachesKeys')
                    console.log(attachesValues,'attachesValues')
                    if(attachesKeys && attachesKeys.length > 0) {
                        this.checkItems1.forEach( item => {
                            if(attachesKeys.find(value =>value == item.name)) {
                                let index = attachesKeys.indexOf(item.name)
                                item.history = attachesValues[index].map(historyItem => {
                                    return {
                                        id:historyItem.id,
                                        is_check:'0',
                                        filepath:`${this.baseUrl}${historyItem.filepath}`
                                    }
                                })
                            }
                        })
                        this.checkItems2.forEach( item => {
                            if(attachesKeys.find(value =>value == item.name)) {
                                let index = attachesKeys.indexOf(item.name)
                                item.history = attachesValues[index].map(historyItem => {
                                    return {
                                        id:historyItem.id,
                                        is_check:'0',
                                        filepath:`${this.baseUrl}${historyItem.filepath}`
                                    }
                                })
                            }
                        })
                    }
                    console.log('最新的field', this.checkItems1, this.checkItems2)
                    let doctor_info = res.data.doctor
                    this.doctorReg.formdata.id = doctor_info.id
                    this.doctorReg.formdata.name = doctor_info.name
                    this.doctorReg.formdata.email = doctor_info.email
                    this.doctorReg.formdata.fax = doctor_info.fax
                    this.doctorReg.formdata.address = doctor_info.address
                    this.doctorReg.formdata.postalcode = doctor_info.postalcode
                    this.doctorReg.formdata.hospital = doctor_info.hospital
                    this.doctorReg.formdata.department = doctor_info.department
                    this.doctorReg.formdata.job = doctor_info.job
                    if(this.isAdopted == null) {
                        if(doctor_info.signature_image) {
                            this.temp_signature_image = doctor_info.signature_image
                            this.doctorReg.formdata.signature_image = doctor_info.signature_image
                            this.sign_img = `${this.baseUrl}${doctor_info.signature_image}`
                        }
                    } else {
                        let attach_info = res.data.attaches
                        if(attach_info && attach_info['医⽣姓名电⼦签名照⽚'] && attach_info['医⽣姓名电⼦签名照⽚'][0] && attach_info['医⽣姓名电⼦签名照⽚'][0].filepath) {
                            this.temp_signature_image = attach_info['医⽣姓名电⼦签名照⽚'][0].filepath
                            this.doctorReg.formdata.signature_image = attach_info['医⽣姓名电⼦签名照⽚'][0].filepath
                            this.sign_img = `${this.baseUrl}${attach_info['医⽣姓名电⼦签名照⽚'][0].filepath}`
                        }
                    }
                }).catch(err=>{
                    console.log(err)
                    this.$toast(err.response.data.message)
                })
            } else {
                console.log('不采用医师平台的信息')
                this.doctorReg.formdata.id = this.doctorInfo.id
                this.doctorReg.formdata.name = this.doctorInfo.name
                //采用之前的医师信息
                // if(this.isAdopted) {
                //     console.log('采用医师平台的信息')
                // GetDoctorDetail({
                //     params:{id:this.doctorInfo.id}
                // }).then( res => {
                //     console.log(res.data.doctor,'泽美医生信息')
                //     console.log(res.data.attaches,'泽美医生材料信息')
                //     let attachesKeys = Object.keys(res.data.attaches)
                //     let attachesValues = Object.values(res.data.attaches)
                //     console.log(attachesKeys,'attachesKeys')
                //     console.log(attachesValues,'attachesValues')
                //     this.checkItems1.forEach( item => {
                //         if(attachesKeys.find(value =>value == item.name)) {
                //             let index = attachesKeys.indexOf(item.name)
                //             item.history = attachesValues[index].map(historyItem => {
                //                 return {
                //                     id:historyItem.id,
                //                     is_check:'0',
                //                     filepath:`${this.baseUrl}${historyItem.filepath}`
                //                 }
                //             })
                //         }
                //     })
                //     this.checkItems2.forEach( item => {
                //         if(attachesKeys.find(value =>value == item.name)) {
                //             let index = attachesKeys.indexOf(item.name)
                //             item.history = attachesValues[index].map(historyItem => {
                //                 return {
                //                     id:historyItem.id,
                //                     is_check:'0',
                //                     filepath:`${this.baseUrl}${historyItem.filepath}`
                //                 }
                //             })
                //         }
                //     })
                //     console.log('最新的field', this.checkItems1, this.checkItems2)
                //     let doctor_info = res.data.doctor
                //     this.doctorReg.formdata.id = doctor_info.id
                //     this.doctorReg.formdata.name = doctor_info.name
                //     this.doctorReg.formdata.email = doctor_info.email
                //     this.doctorReg.formdata.fax = doctor_info.fax
                //     this.doctorReg.formdata.address = doctor_info.address
                //     this.doctorReg.formdata.postalcode = doctor_info.postalcode
                //     this.doctorReg.formdata.hospital = doctor_info.hospital
                //     this.doctorReg.formdata.department = doctor_info.department
                //     this.doctorReg.formdata.job = doctor_info.job
                //     if(doctor_info.signature_image) {
                //         this.temp_signature_image = doctor_info.signature_image
                //         this.doctorReg.formdata.signature_image = doctor_info.signature_image
                //         this.sign_img = `${this.baseUrl}${doctor_info.signature_image}`
                //     }
                //     }).catch(err=>{
                //         console.log(err)
                //         this.$toast(err.response.data.message)
                //     })
                // } else {
                //     console.log('不采用医师平台的信息')
                //     this.doctorReg.formdata.id = this.doctorInfo.id
                //     this.doctorReg.formdata.name = this.doctorInfo.name
                // }
            }
            this.$toast.clear()
        },

        async getImgData() {
            await GetDoctorDetail({
                params:{id:this.doctorInfo.id}
            }).then( res => {
                console.log(res,'医生信息')
                let attachesKeys = Object.keys(res.data.attaches)
                let attachesValues = Object.values(res.data.attaches)
                this.checkItems1.forEach( item => {
                    item.history = []
                    if(attachesKeys.find(value =>value == item.name)) {
                        let index = attachesKeys.indexOf(item.name)
                        item.history = attachesValues[index].map(historyItem => {
                            return {
                                id:historyItem.id,
                                is_check:'0',
                                filepath:`${this.baseUrl}${historyItem.filepath}`
                            }
                        })
                    }
                })
                this.checkItems2.forEach( item => {
                    item.history = []
                    if(attachesKeys.find(value =>value == item.name)) {
                        let index = attachesKeys.indexOf(item.name)
                        item.history = attachesValues[index].map(historyItem => {
                            return {
                                id:historyItem.id,
                                is_check:'0',
                                filepath:`${this.baseUrl}${historyItem.filepath}`
                            }
                        })
                    }
                })
                console.log('更新后的field', this.checkItems1, this.checkItems2)
            })
        },

        //切换二选一认证材料
        handleCheckboxChange(val) {
            if(this.mType[0]) {
                if(this.mType[0] != val) {
                    this.mType = []
                    this.mType.push(val)
                }
            }
            console.log(val,'val')
            console.log(this.mType,'this.mType')
        },

        //处理设置签名
        handleImageBoxConfig() {
            if(this.temp_signature_image) {
                this.preSignImg = `${this.baseUrl}${this.temp_signature_image}`
                this.showPreSignature = true
            } else {
                this.showSignImgBox = false
            }
        },

        //确认使用医师公益平台的签名
        confirmPreSign() {
            this.sign_img = this.preSignImg
            this.doctorReg.formdata.signature_image = this.preSignImg.split(this.baseUrl)[1]
            this.showPreSignature = false
        },
        //重新签名
        reSign() {
            this.temp_signature_image = ''
            this.sign_img = ''
            this.showPreSignature = false
            this.showSignImgBox = false
        },

        //选择职称
        getJob(val) {
            this.doctorReg.formdata.job = val
            this.showJob = false
        },

        //删除历史材料图片
        deleteCI(val) {
            Dialog.confirm({
                message: '确定删除？',
            })
            .then(() => {
                RemoveDocInfoAttach({
                    id: val
                }).then( async () => {
                    await this.getImgData()
                    this.$forceUpdate()
                }).catch((err) => {
                    this.$toast(err.response.data.message)
                })
            })
            .catch((err) => {
                // console.log(err);
            });
        },

        //展示医院搜索列表框
        showHospitalSearch() {
            // console.log(this.hospitalKeywords)
            this.showHospital = true
        },

        //根据搜索框的输入展示医院数据
        // getSearchHosResult(val) {
        //     console.log(val,'val');
        //     console.log(val.length);
        //     if(!val) {
        //         this.$toast('请输入医院名称去匹配医院')
        //         return
        //     }
        //     if(val.length <= 1) {
        //         this.$toast("请输入至少两个字符的信息去匹配医院")
        //         return
        //     }
        //     if(val === '医院') {
        //         this.$toast("请输入更详细的信息去匹配医院")
        //         return
        //     }
        //     this.$toast.loading({
        //         duration:0,
        //         forbidClick:true
        //     })
        //     this.hospitalKeywords = val
        //     GetDoctorHospital({name:val}).then( res => {
        //         if(res.data.length == 0){
        //             this.$toast.clear()
        //             this.$toast("无匹配的医院")
        //             this.searchHospitalResults = this.hospitalResults
        //             return
        //         }
        //         console.log(res);
        //         this.searchHospitalResults = res.data
        //         this.$toast.clear()
        //     }).catch( err => {
        //         this.$toast.clear()
        //         this.$toast(err.response.data.message)
        //     })
        // },

        //根据搜索框的输入展示医院数据
        getSearchHosResult() {
            // console.log(this.hospitalKeyWords,'this.hospitalKeyWords');
            // console.log(this.hospitalKeyWords.length);
            // if(!this.hospitalKeyWords) {
            //     this.$toast('请输入医院名称去匹配医院')
            //     return
            // }
            // if(this.hospitalKeyWords.length <= 1) {
            //     this.$toast("请输入至少两个字符的信息去匹配医院")
            //     return
            // }
            // if(this.hospitalKeyWords === '医院') {
            //     this.$toast("请输入更详细的信息去匹配医院")
            //     return
            // }
            // this.$toast.loading({
            //     duration:0,
            //     forbidClick:true
            // })
            // this.hospitalKeywords = this.hospitalKeyWords
            // GetDoctorHospital({name:this.hospitalKeyWords}).then( res => {
            //     if(res.data.length == 0){
            //         this.$toast.clear()
            //         this.$toast("无匹配的医院")
            //         this.searchHospitalResults = this.hospitalResults
            //         return
            //     }
            //     console.log(res);
            //     this.searchHospitalResults = res.data
            //     this.$toast.clear()
            // }).catch( err => {
            //     this.$toast.clear()
            //     this.$toast(err.response.data.message)
            // })
        },

        closeHospitalSearch() {
            this.showHospital = false
            // this.searchHospitalResults = this.hospitalResults
        },

        //选中列表中的医院
        chooseHospital(val) {
            this.doctorReg.formdata.hospital = val.name
            this.showHospital = false
            // this.hospitalKeywords = ''
            // this.searchHospitalResults = this.hospitalResults
            console.log(this.doctorReg.formdata,'选中医院后的当前表单')
        },

        //根据搜索框的输入展示科室数据
        getSearchDepResult(val) {
            if(!val) {
                this.$toast('请输入科室名称')
                this.searchDepartmentResults = this.departmentResults
                return
            } else {
                this.searchDepartmentResults = this.departmentResults.filter( item => {
                    return +item.indexOf(val)+1
                })
                if(this.searchDepartmentResults.length == 0){
                    this.$toast("无匹配的科室")
                }
            }
        },
        
        closeDepartmentSearch() {
            this.showDepartment = false
            this.searchDepartmentResults = this.departmentResults
        },
        
        //选中列表中的科室
        chooseDepartment(val) {
            this.doctorReg.formdata.department = val
            this.departmentKeywords = ''
            this.searchDepartmentResults = this.departmentResults 
            this.showDepartment = false
            console.log(this.doctorReg.formdata,'选中科室后的当前表单')
        },

        //放大显示签名的图片
        showImage(src) {
            let images = []
            images.push(src)
            ImagePreview({
                images,
                closeable: true,
            })
        },

        //清空签字板的数据
        clear: function() {
            draw.clear()
        },

        //签名数据保存
        save: function() {
            if (isDraw) {
                var data = draw.save()
                this.sign_img = data
                this.doctorReg.formdata.signature_image = data
                this.showSignImgBox = true
                console.log(data,'签名数据')
            } else {
                this.$toast("请先手写签名再点击保存")
            }
        },

        //提交医生表单信息
        submitForm() {
            this.submitBtnDisabled = true
            if(!this.doctorReg.formdata.email) {
                this.submitBtnDisabled = false
                this.$toast('邮箱不能为空')
                return
            }
            let testReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
            if (!testReg.test(this.doctorReg.formdata.email)) {
                this.submitBtnDisabled = false
                this.$toast('请输入正确的邮箱')
                return
            }
            if(!this.doctorReg.formdata.address) {
                this.submitBtnDisabled = false
                this.$toast('联系地址不能为空')
                return
            }
            if (this.doctorReg.formdata.hospital == '' || this.doctorReg.formdata.hospital == '请选择所属医院') {
                this.submitBtnDisabled = false
                this.$toast('请选择所属医院')
                return
            }
            if (this.doctorReg.formdata.department == '' || this.doctorReg.formdata.department == '请选择科室') {
                this.submitBtnDisabled = false
                this.$toast('请选择科室')
                return
            }
            if (this.doctorReg.formdata.job == '' || this.doctorReg.formdata.job == '请选择职称') {
                this.submitBtnDisabled = false
                this.$toast('请选择职称')
                return
            }
            if (this.sign_img == '') {
                this.submitBtnDisabled = false
                this.$toast('请设置手写签名')
                return
            }
            let ci = []
            if (this.mType[0] == 1) {
                ci = this.checkItems1
                console.log(ci,'选项一的材料')
            } else if (this.mType[0] == 2) {
                ci = this.checkItems2
                console.log(ci,'选项二的材料')
            }

            for (let index = 0; index < ci.length; index++) {
                const element = ci[index];
                if (element.images.length == 0) {
                    if (element.history.length == 0) {
                        this.submitBtnDisabled = false
                        this.$toast("请上传" + element.name + "相关资料");
                        return;
                    }
                }
            }

            for(let i=0;i<ci.length;i++) {
                let allSendImages = []
                let key = ci[i].field
                ci[i].images.forEach( item => {
                    allSendImages.push({
                        src: item.src.split(this.baseUrl)[1]
                    })
                })
                this.doctorReg.formdata.attaches[key] = allSendImages
                console.log(this.doctorReg.formdata.attaches,'当前表单的attach数据')
            }
            SubmitDoctorInfo(this.doctorReg.formdata).then( res => {
                console.log(this.doctorReg.formdata,'this.doctorReg.formdata');
                this.submitBtnDisabled = false
                this.$router.replace({
                    name:'DoctorMsg',
                    query:{
                        value:'医生提交'
                    }
                })
                console.log(res,'提交成功')
            }).catch( err => {
                this.submitBtnDisabled = false
                this.$toast(err.response.data.message)
            })
        },
    }
}
</script>
<style lang="less">
@import "~@/style/base.less";
.doctor-apply {
    .dark-shadow-box {
        margin: 7px;
        box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.4);
    }
    .doctor-cell-group {
        .shadow-box {
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        }
        .van-cell-group {
            .van-cell--required {
                &::before {
                    content: '';
                }
                .van-cell__title.van-field__label {
                    span {
                        &::after{
                            color: #ee0a24;
                            font-size: 14px;
                            content: '*';
                        }
                    }
                }
            }
            .van-cell {
                .van-field__label {
                    display:flex;
                    align-items: center;
                    span {
                        color: #696a69;
                    }
                }
                .van-field__value {
                    color: #9d9d9d;
                }
            }
        }
    }

    .confirm-checkitems{
        .custom-title {
            padding: 7px 16px;
            font-size: 16px; 
            font-weight: bold; 
            color: #333;
        }
        .sub-title {
            padding: 7px 16px;
            color:rgba(0, 0, 0, 0.4)
        }
        .checkboxStyle {
            padding: 15px 0;
            &.shadow-box {
                margin-top: 0;
                margin-bottom: 0;
                padding-left: 10px;
            }
            .van-checkbox {
                padding: 2px 7px;
                border: 1px solid #c8c9cc;
                border-radius: 20px;
                .van-checkbox__icon{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .van-icon {
                        height: 16px;
                        width: 16px;
                        line-height: initial;
                    }
                }
                &[aria-checked="true"] {
                    border: 1px solid @theme-color;
                    background-color: @theme-color;
                    .van-checkbox__icon{
                        .van-icon {
                            border-color: @theme-color;
                            color:@theme-color;
                            background-color: #fff;
                        }
                    }
                    .van-checkbox__label {
                        color: #fff;
                    }
                }
            }
        }
    }

    .sign-img-box {
        .van-cell {
            padding: 10px;
            .van-cell__value {
                flex:initial;
                color: initial;
            }
        }
        .sign_img {
            background: #f6f7f8; width: 50%; height: 0px; padding-top: 50%; overflow: hidden; margin: auto; position: relative; border-radius: 10px;
            img {
            width: 100%; height: 100%; object-fit: contain; display: block; position: absolute; top: 0; right: 0; bottom: 0; left: 0;
            }
        }
    }

    .doc-agree {
        padding: 2px 16px;
        .van-icon {
            height: 16px;
            width: 16px;
            line-height: initial;
        }
    }

}
.doctor-register {
    .pre-signature {
        .signature-box {
            height: 75vh;
            margin: 20px 17px 4px 14px;
            background-color: #ECEDEC;
            .van-image {
                height: 100%;
                img {
                    object-fit: contain;
                    height: 100%;
                }
            }
        }
        .signature-tips {
            padding: 19px 12px 5px 18px;
            color: #E30A0A;
            font-size: 14px;
        }
    }
    .van-popup-fixbox {
        position: relative;
        .van-search {
            position: fixed;
            z-index: 2009;
            width: 100%;
            // border-radius: 50px;
        }

        .van-cell-group {
            padding-top: 50px;
        }
    }
    .btn {
        padding-top: 7px;
        .back {
            border-color:@theme-color;
            color: @theme-color;
        }
        .up {
            background-color: @theme-color;
        }
    }
    .canvas-page {
        text-align: center;
        padding-bottom: 48px;
        height: 100vh;
        box-sizing: border-box;
        position: relative;
        .canvas-box {
            height: 100%;
            position: relative;
        }
        #canvas {
            background:#F3FCFD center center no-repeat;
            background-image: url("../../assets/broad_bg.png");
            background-size: auto 75%;
            border: #A5E4E7 solid 1px;
            cursor: default;
            margin: 15px auto;
            // position: absolute;
            // top: 0;
            // left: 0;
            // right: 0;
            // bottom: 0;
            // margin: auto;
        }
    }
}
.search-hospital-button {
    display: flex;
    .action-btn {
        // min-height: 50px;
        width: 100%;
        z-index: 999;
        margin-right: 10px;
        .up {
            width: 100%;
            height: 34px;
            // line-height: 34px;
            border-radius: 20px;
            background-color: @theme-color;
            color: rgba(246, 248, 255, 1);
            font-size: 12px;
            text-align: center;
            margin: auto auto;
        }
    }
    .cancel-btn {
        display: flex;
        align-items: center;
        width: 50%;
    }
}
.van-popup-search-box {
    .van-search {
        .van-search__action {
            line-height: initial;
        }
    }
}
</style>
